export const FALLBACK_IMAGE_PATH = '/images/products/fallback-image.svg'
